<template>

  <section v-if="company_video && company_video.length > 0" class="short">
    <h2 class="ttl-short">企業ショート動画</h2>
    <div class="video-list">
      <div class="video-list__wrap">
        <div class="swiper">
          <!-- @vue-ignore -->
          <swiper
              :navigation="swiperOptions.navigation"
              :modules="swiperOptions.modules"
              :slides-per-view="swiperOptions.slidesPerView"
              :loop="swiperOptions.loop"
              :speed="swiperOptions.speed"
              :autoplay="swiperOptions.autoplay"
              :breakpoints="swiperOptions.breakpoints"
              :slides-per-group="swiperOptions.slidesPerGroup"
          >
            <swiper-slide v-for="(video,i) in props.company_video">
              <a :href="'/companies/'+video.company_id + '#video'+video.video_id">
                <img :src="video.img_url">
                <div class="video-caption">{{ video.title }}</div>
              </a>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div class="video-list__next" @click="next"></div>
    </div>
  </section>
</template>
<script setup lang="ts">
import {Swiper, SwiperSlide} from "swiper/vue";
import {Autoplay, Navigation} from "swiper/modules";
import 'swiper/swiper-bundle.css';

const props = defineProps({
  company_video: {
    type: Array,
    required: true
  }
});

const next = ()=>{
  document.querySelector('.swiper-button-next').click();
}

const swiperOptions = {
  modules: [Autoplay, Navigation],
  slidesPerView: 3,
  slidesPerGroup: 1,
  loop: true,
  speed: 700,
  breakpoints: {
    765: {
      slidesPerView: 5,
    },
    1379: {
      slidesPerView: 6,
    },
    1662: {
      slidesPerView: 7,
    },
    1945: {
      slidesPerView: 8,
    },
    2228: {
      slidesPerView: 9,
    },
    2511: {
      slidesPerView: 10,
    }
  },
  navigation: true,
  autoplay: {
    delay: 3000,
  }
};


</script>